import cx from 'classnames';
import { Button } from '../Button';
import styles from './SceneLoadError.module.css';

type SceneLoadErrorProps = {
  visible: boolean;
  message: string;
  hint?: string;
  reloadLabel: string;
};

export const SceneLoadError = ({
  visible,
  message,
  hint,
  reloadLabel,
}: SceneLoadErrorProps) => (
  <div className={cx(styles.overlay, !visible && styles.hidden)}>
    <div className={styles.text}>
      <p className={styles.message}>{message}</p>
      {hint && <p className={styles.hint}>{hint}</p>}
    </div>
    <Button
      type="button"
      appearance="primary"
      onClick={() => window.location.reload()}
    >
      {reloadLabel}
    </Button>
  </div>
);
